import { Box, Button, CircularProgress, Link, Typography } from '@mui/material';
import { useApi } from 'contexts/Api/Api';
import { useContent } from 'contexts/Content/Content';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { Fragment } from 'react';
import Image from '../Image/Image';
import LandingCards from '../LandingCards/LandingCards';
import { Container, Left, LeftContent, Points, Right } from './Landing.styled';

export default function Landing() {
    const api = useApi();
    const content = useContent();
    const game = useGame();
    const page = usePage();

    const startLesson = api.resumeLesson || '1.1';
    const buttonDisabled = api.loading;

    function handleSubmit(e: any) {
        e.preventDefault();
        page.show(startLesson);
    }

    return (
        <Container $backgroundImage={content.landing.background}>
            <Box flex={2} padding={6}>
                <Left $split={false}>
                    <LeftContent $center>
                        <Typography marginBottom={5} paragraph variant="montserrat848">
                            {content.landing.title}
                        </Typography>
                        <Box component="form" onSubmit={handleSubmit}>
                            <Box display="inline-block">
                                <Button
                                    aria-label={content.landing.startButton}
                                    data-testid="landing-play-button"
                                    disabled={buttonDisabled}
                                    size="large"
                                    startIcon={api.loading && <CircularProgress color="inherit" size="18px" />}
                                    type="submit"
                                >
                                    {content.landing.startButton}
                                </Button>
                                {game.history['6.1-start'] && (
                                    <Typography align="center" marginTop={1.5} paragraph variant="montserrat418">
                                        or&nbsp;
                                        <Link
                                            aria-label={content.landing.practiceButton}
                                            color="inherit"
                                            component="button"
                                            data-testid="landing-practice-link"
                                            fontWeight={700}
                                            type="button"
                                            onClick={() => page.show('6.1')}
                                        >
                                            {content.landing.practiceButton}
                                        </Link>
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </LeftContent>
                    <LandingCards />
                </Left>
            </Box>
            <Right>
                <Typography
                    dangerouslySetInnerHTML={{ __html: content.landing.text }}
                    display="flex"
                    flexDirection="column"
                    gap={3}
                    marginBottom={5}
                    variant="montserrat418"
                />
                <Points>
                    {[
                        content.landing.point1,
                        content.landing.point2,
                        content.landing.point3,
                        content.landing.point4,
                    ].map((point, index) => (
                        <Fragment key={index}>
                            <Image alt={point.iconAlt} src={point.icon} />
                            <Typography variant="montserrat418">{point.label}</Typography>
                        </Fragment>
                    ))}
                </Points>
            </Right>
        </Container>
    );
}
